var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    fill: "none",
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M3.2 2.002C3.834 1.347 4.596.832 5.44.487 6.284.143 7.19-.023 8.1.002c.91-.009 1.81.163 2.652.507.841.343 1.606.851 2.248 1.494.643.642 1.15 1.407 1.494 2.248.344.841.516 1.743.506 2.651-.01 1.136-.249 2.258-.7 3.3-.5 1.216-1.101 2.387-1.8 3.5-.7 1.1-1.4 2.1-2 3.1-.501.813-1.07 1.582-1.7 2.3l-.8.8c-.2-.2-.4-.5-.8-.9-.612-.696-1.18-1.431-1.7-2.2-.8-1.1-1.5-2.1-2.1-3.1-.646-1.091-1.214-2.228-1.7-3.4-.48-1.072-.75-2.226-.8-3.4.222-1.837 1.028-3.555 2.3-4.9zm3.2 6.7c.42.459.987.755 1.602.84.616.084 1.242-.05 1.77-.377.527-.328.923-.83 1.12-1.42.196-.59.18-1.229-.045-1.808-.225-.579-.645-1.061-1.189-1.363-.543-.302-1.174-.404-1.785-.29-.61.115-1.162.44-1.559.917-.396.478-.614 1.08-.614 1.701-.013.333.042.664.162.974.12.31.304.59.538.826z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.1af7c0d9.svg";
export { ForwardRef as ReactComponent };